import { render } from "./EventEditor.vue?vue&type=template&id=44bea484"
import script from "./EventEditor.vue?vue&type=script&lang=js"
export * from "./EventEditor.vue?vue&type=script&lang=js"

import "./EventEditor.vue?vue&type=style&index=0&id=44bea484&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__